module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO12Efectividad (ant43).bfcb8fe.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO12Efectividad (ant43).mp4
// module id = 738
// module chunks = 1